import React from 'react';
import { Box, Stack, Paper } from '@mui/material';
import { Table, TableBody, TableContainer, TableHead, TableRow, Button, Typography, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AccordionSummary, AccordionDetails, Accordion } from '../shared/components/accordion';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import DocumentForm from '../shared/components/documentForm';
import ConfirmDialog from '../shared/components/confirmDialog';
import { FormMode } from '../utils/extensions/constantEx'

const PatientDocumentView = (props) => {
    const { expanded, patientDocuments, loggedUser, formOpenMode, handleDocumentChange, handleAccordionChange,
        showAPIError, openErrorAlert, handleRemovedPatientDocumentIdsChange
    } = props;

    const [isOpenDocumentForm, setIsOpenDocumentForm] = React.useState(false);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState(0);
    const [nextDocId, setNextDocId] = React.useState(0);
    const [selectedDocument, setSelectedDocument] = React.useState(null);

    const handleAddClick = () => {
        setSelectedDocument(null);
        setIsOpenDocumentForm(true);
    }

    const handleSaveClick = (docFormValue) => {
        setIsOpenDocumentForm(false);

        let tempNextId = nextDocId - 1;

        const tempDocs = [...patientDocuments];
        if (docFormValue) {
            tempDocs.push({ ...docFormValue, id: tempNextId });
        }

        setNextDocId(tempNextId);
        handleDocumentChange([...tempDocs]);
    }

    const handleCancelClick = () => {
        setIsOpenDocumentForm(false);
        setSelectedDocument(null);
    }

    const handleDeleteClick = (id) => {
        setSelectedId(id);
        setIsDeleteConfirmOpen(true);
    }

    const handleDeleteOKClick = () => {
        let removedDocId = 0;

        const tempSelectedDoc = [...patientDocuments.filter(col => col.id === selectedId)];
        if (tempSelectedDoc.length > 0) {
            removedDocId = tempSelectedDoc[0].uploadedFileId;
        }
        const tempDocs = [...patientDocuments.filter(col => col.id !== selectedId)];
        handleRemovedPatientDocumentIdsChange(selectedId, removedDocId);
        handleDocumentChange([...tempDocs]);

        setIsDeleteConfirmOpen(false);
        setSelectedId(0);
    }

    const handleDeleteCancelClick = () => {
        setSelectedId(0);
        setIsDeleteConfirmOpen(false);
    }

    const handleEditClick = (id) => {
        const tempSelectedDoc = [...patientDocuments.filter(col => col.id === id)];
        if (tempSelectedDoc.length > 0) {
            setSelectedDocument(tempSelectedDoc[0]);
            setIsOpenDocumentForm(true);
            return;
        }
        setSelectedDocument(null);
    }

    return (

        <Accordion expanded={expanded === 'panelPatientDocument'} onChange={handleAccordionChange('panelPatientDocument')}>
            <AccordionSummary id="panel-patient-documents">
                <Typography>Patient Documents</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack spacing={1}>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Box sx={{ pr: 1, float: 'right' }}>
                                <Stack direction="row" spacing={2}>
                                    {
                                        isDeleteConfirmOpen &&
                                        <ConfirmDialog isOpen={isDeleteConfirmOpen} title="Confirm Remove"
                                            message="Are you sure you want to remove the document?"
                                            handleClickOK={handleDeleteOKClick}
                                            handleClickCancel={handleDeleteCancelClick} />

                                    }
                                    {
                                        isOpenDocumentForm &&
                                        <DocumentForm isOpen={isOpenDocumentForm} isProfilePhoto={false} loggedUser={loggedUser}
                                            handleSaveClick={handleSaveClick} showAPIError={showAPIError} openErrorAlert={openErrorAlert}
                                            handleCancelClick={handleCancelClick} selectedDocument={selectedDocument} />
                                    }
                                    {
                                        formOpenMode !== FormMode.ViewMode &&
                                        <Button variant="contained" onClick={handleAddClick}>Add</Button>
                                    }
                                </Stack>
                            </Box>
                        </Grid>
                        <Grid size={12}>
                            <TableContainer component={Paper} sx={{ maxHeight: '77vh' }}>
                                <Table stickyHeader sx={{ minWidth: 700 }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell sx={{ width: '250px' }}>Document</StyledTableCell>
                                            <StyledTableCell sx={{ width: '300px' }}>No</StyledTableCell>
                                            <StyledTableCell sx={{ width: '550px' }}>File Name</StyledTableCell>
                                            <StyledTableCell>Notes</StyledTableCell>
                                            <StyledTableCell sx={{ width: '50px' }}>&nbsp;</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {patientDocuments.map((row) => (
                                            <StyledTableRow key={row.id.toString()}>
                                                <StyledTableCell component="th" scope="row">
                                                    {
                                                        !row.documentType ? '' :
                                                            (row.documentType === 'Aadhaar' ? 'Aadhaar' :
                                                                (row.documentType === 'DrivingLicence' ? 'Driving Licence' :
                                                                    (row.documentType === 'RationCard' ? 'Ration Card' :
                                                                        (row.documentType === 'VoterID' ? 'Voter ID' :
                                                                            (row.documentType === 'PaymentReceipt' ? 'Payment Receipt' :
                                                                                (row.documentType === 'SalaryReceipt' ? 'Salary Receipt' : row.documentType)
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                    }
                                                </StyledTableCell>
                                                <StyledTableCell>{row.no}</StyledTableCell>
                                                <StyledTableCell>{row.fileName}</StyledTableCell>
                                                <StyledTableCell>{row.notes}</StyledTableCell>
                                                <StyledTableCell>
                                                    {
                                                        formOpenMode !== FormMode.ViewMode &&
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            {/* <IconButton size="small" onClick={() => handleEditClick(row.id)}>
                                                                <EditIcon fontSize="inherit" />
                                                            </IconButton> */}
                                                            <IconButton size="small" onClick={() => handleDeleteClick(row.id)}>
                                                                <RemoveCircleOutlineIcon fontSize="small" />
                                                            </IconButton>
                                                        </Stack>
                                                    }
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Stack>
            </AccordionDetails>
        </Accordion>

    );
}
export default PatientDocumentView;